/**
 * This is a list of remote config keys that are used in Lab.
 *
 * Remote configs are static key-value pairs that don't require audience targeting.
 * They are fetched once during SSR and stored in Redux.
 */
export enum LabRemoteConfigKeys {
  luxPlusPromoCardCarousel = 'loyalty:luxplusPromoCardCarousel',
  luxPlusPromoBannerCarousel = 'loyalty:luxplusPromoBannerCarousel',
  luxPlusOfferVoucher = 'loyalty:luxPlusOfferVoucher',
  loyaltyOffersHubPage = 'loyalty:societeOffersHubPage',
  loyaltySpendPointsPage = 'loyalty:societeSpendPointsPage',
  loyaltyAccountWhatsNew = 'loyalty:societeAccountWhatsNew',
  loyaltyActionRewardsSection = 'loyalty:societeActionRewardsSection',
  loyaltyEsimUpsell = 'loyalty:esimUpsell',
  loyaltyPaypalTriplePointCampaign = 'loyalty:paypal3xCampaign',
  languages = 'languages',
}

/**
 * This is a list of feature flags that are used in Lab.
 *
 * Note: All feature flags are `false` by default
 * unless they are explicitly assigned to `true` in the respective variants in the LE Lab UI.
 *
 * Therefore, a good practice is to name the feature flags to reflect the default behaviour
 * e.g. `enable_lux_plus_feature` for the default behaviour of the feature being disabled.
 */
export enum LabFeatureFlags {
  // Site Takeover flags
  enableHeroCarouselTakeover = 'enableHeroCarouselTakeover',
  enableSiteTakeover = 'enableSiteTakeover',
  enableOfferCampaignTag = 'enableOfferCampaignTag',
  enableTakeoverBannerContent = 'enableTakeoverBannerContent',
  enableTakeoverModal = 'enableTakeoverModal',
  enableTakeoverUSP = 'enableTakeoverUSP',
  enableTakeoverSearchTileBanner = 'enableTakeoverSearchTileBanner',
  // Flag to enable home page carousel reorder (excl hero carousel)
  enableHomePageCarouselReorder = 'enableHomePageCarouselReorder',
  // Targeted Banner for emergency announcement
  enableTopBannerMessage = 'enableTopBannerMessage',
  // Flag for lab-CP E2E integration (DON'T CHANGE)
  enableE2ELabIntegration = 'enableE2ELabIntegration',
  // Funnel Optimiser - checkout flow customization based on audience
  enableFunnelOptimiser = 'enableFunnelOptimiser',
  // Temptations Beach Club audience banner
  enableTemptationsBeachClubBanner = 'enableTemptationsBeachClubBanner',
  // Société tier upgrade campaign
  enableTierUpgradeCampaign = 'enableTierUpgradeCampaign',
  // Société status match campaign
  enableStatusMatch = 'enableStatusMatch',
  // Société credit card landing page
  societeCreditCardFlag = 'loyalty:societeCreditCardFlag',
  // Language selector button in header
  enableLanguageSelector = 'enableLanguageSelector',
  // LERE dynamic pricing group assignment
  enableLereDynamicPricingGroup = 'enableLereDynamicPricingGroup',
  // Dedicated staff-facing insurance comparison experience in spoof checkout.
  enableSpoofInsuranceComparisonFlow = 'enableSpoofInsuranceComparisonFlow',
}
